import { ref, computed } from "vue";
import { Renraku, RenrakuList, SearchItem } from "@/types/KaisyaRenraku";
import { RenrakuService } from "@/service/RenrakuService";

/*
 * 初期処理
 */
export function useSearch() {
  const loading = ref(0); // APIで読み込みをする本数
  const isError = ref(false);

  const searchItem = ref<SearchItem>({
    keyword: null,
    date: null,
    readType: 0,
    dataType: 1,
    buka: null,
    userId: null
  });
  const list = ref<RenrakuList[]>([]);

  // ログインユーザーに関連する会社連絡で既読以外を取得する
  const srv = new RenrakuService();

  const search = async(serchItem: SearchItem) => {
    loading.value++
    const res = await srv.getRenrakuListForSearch(serchItem)
    loading.value--
    return res
  }

  // 読み込み中か判断する
  const isSearching = computed(() => {
    return !(loading.value === 0 || isError.value)
  });

  return {
    isSearching,
    isError,
    list,
    search,
    searchItem,
  }
}
